export const CREATE_DESIGNATION = 'common@create-designation';
export const CREATE_AND_UPDATE_DESIGNATION = 'common@create-and-update-designation';
export const DELETE_DESIGNATION = 'common@delete-designation';
export const UPDATE_DESIGNATION = 'common@update-designation';

